import { isEmpty } from 'lodash'

import { matchText } from 'modules/core/lib/stringUtils'

import surveys from 'modules/surveys/store/collections/v2/surveys'
import type Survey from 'modules/surveys/store/models/v2/Survey'

export const filterBySearch = (search: string): Survey[] => {
  if (isEmpty(search)) return surveys.models.slice()

  return surveys.models.filter((survey: Survey) => matchText(search, survey.attributes.name))
}

export const filterByStatus = (filteredBySearch: Survey[], status: string): Survey[] => {
  if (!status.length) return filteredBySearch

  return filteredBySearch.filter((survey: Survey) => survey.attributes.status === status)
}
